import { InputAdornment as MaterialInputLabel } from '@mui/material'

const InputAdornment = MaterialInputLabel

export { InputAdornment }
